import ApiClient from "../helpers/ApiClient";

const baseCertificadoEndpoint = (cnpj) => `/gestao/empresa/${cnpj}/certificado`;

const getCertificado = (cnpj) =>
  ApiClient.apiClientDef.get(baseCertificadoEndpoint(cnpj));

const postCertificado = (cnpj, data) =>
  ApiClient.apiClientDef.post(baseCertificadoEndpoint(cnpj), data);

const renovaCertificado = (cnpj, data) =>
  ApiClient.apiClientDef.post(`${baseCertificadoEndpoint(cnpj)}/renovar`, data);

const buscaCertificadosVencer = (params) =>
  ApiClient.apiClientDef.get(`/gestao/certificado_vencer`, { params });

const getContatoEmpresa = (uid) =>
  ApiClient.apiClientDef.get(`/gestao/certificado_vencer/${uid}`);

const CertificadoApiClient = {
  getCertificado,
  postCertificado,
  renovaCertificado,
  buscaCertificadosVencer,
  getContatoEmpresa,
};
export default CertificadoApiClient;
